import type { ComponentType, FunctionComponent } from 'react';

import './style.scss';

type PropsT = {
  Icon: ComponentType;
  checked: boolean;
  label: string;
  onSwitch: () => void;
};

const OptionRow: FunctionComponent<PropsT> = ({
  Icon,
  checked,
  label,
  onSwitch,
}) => (
  <div
    onClick={onSwitch}
    onKeyDown={(e) => {
      if (e.key === 'Enter') onSwitch();
    }}
    role="button"
    styleName="row"
    tabIndex={0}
  >
    <Icon styleName="rowIcon" />
    <div styleName="rowLabel">{label}</div>
    <div styleName={checked ? 'indicator checked' : 'indicator'} />
  </div>
);

export default OptionRow;
